// extracted by mini-css-extract-plugin
module.exports = {"loginButton":"SignInSsoButton_loginButton__deUGG"};